<template>
    <div class="gr">
        <div class="gr__header">
            <h3 class="gr__title">РЕЙТИНГ / GPS</h3>
            <select v-model="selectedGroupId" class="gr__select" @change="loadRating">
                <option :value="null">Всі команди</option>
                <option v-for="group in groups" :key="group.group_id" :value="group.group_id">
                    {{ group.name }}
                </option>
            </select>
        </div>

        <div class="gr__list" v-if="players.length > 0">
            <div v-for="(player, index) in players" :key="player.playerId" 
                class="gr__item" :class="{'gr__item--top': index < 3}">
                <div class="gr__num-wrap">
                    <span class="gr__num">{{ player.playerNumber || '-' }}</span>
                </div>
                <div class="gr__info">
                    <span class="gr__name">{{ player.playerName }}</span>
                    <span class="gr__team">{{ player.teamName }}</span>
                </div>
                <div class="gr__score-wrap">
                    <span class="gr__score">{{ player.gpsScore }}</span>
                </div>
                <div class="gr__rank" :class="getRankClass(index + 1)">
                    {{ index + 1 }}
                </div>
            </div>
        </div>

        <div v-else class="gr__empty">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" opacity="0.2">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="#339989" stroke-width="1.5"/>
            </svg>
            <span>Немає даних рейтингу</span>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { getGpsRating, getAllGroups } from '@/desktopApp/services/apiRequests'
import { useMainStore } from '@/desktopApp/stores/mainStore'

export default {
    name: 'GpsRating',

    setup() {
        const store = useMainStore()
        const groups = ref([])
        const selectedGroupId = ref(null)
        const players = ref([])

        const loadRating = async () => {
            try {
                const data = await getGpsRating(selectedGroupId.value)
                players.value = data || []
            } catch (e) {
                players.value = []
            }
        }

        const getRankClass = (rank) => {
            if (rank === 1) return 'gr__rank--gold'
            if (rank === 2) return 'gr__rank--silver'
            if (rank === 3) return 'gr__rank--bronze'
            return ''
        }

        onMounted(async () => {
            const position = (store.trainer_position || '').toLowerCase()
            const isMethodist = position.includes('метод') || position.includes('method')
            const isGoalkeeperTrainer = position.includes('goalkeeper_trainer')
            const isIndividualTrainer = position.includes('individual_trainer')

            if (isMethodist || isGoalkeeperTrainer || isIndividualTrainer) {
                try {
                    const groupsData = await getAllGroups()
                    groups.value = groupsData.data || groupsData || []
                } catch (e) {
                    groups.value = store.trainer_groups || []
                }
                selectedGroupId.value = null
            } else {
                groups.value = store.trainer_groups || []
                if (groups.value.length) {
                    selectedGroupId.value = groups.value[0].group_id
                }
            }
            await loadRating()
        })

        return { groups, selectedGroupId, players, loadRating, getRankClass }
    }
}
</script>

<style scoped>
.gr {
    background: linear-gradient(180deg, #1c1c1e 0%, #161618 100%);
    border: 1px solid rgba(255, 255, 255, 0.04);
    border-radius: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.gr__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 18px;
    background: rgba(51, 153, 137, 0.04);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.gr__title {
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
}

.gr__select {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #ccc;
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 11px;
    outline: none;
    cursor: pointer;
    transition: border-color 0.2s;
}

.gr__select:hover {
    border-color: rgba(51, 153, 137, 0.4);
}

.gr__list {
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #333 transparent;
}

.gr__item {
    display: flex;
    align-items: center;
    padding: 10px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
    transition: background-color 0.15s;
}

.gr__item:hover {
    background: rgba(255, 255, 255, 0.02);
}

.gr__item--top {
    background: rgba(51, 153, 137, 0.03);
}

.gr__num-wrap {
    min-width: 32px;
}

.gr__num {
    color: #C59014;
    font-weight: 800;
    font-size: 15px;
}

.gr__info {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 6px;
    min-width: 0;
}

.gr__name {
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.gr__team {
    color: rgba(255, 255, 255, 0.3);
    font-size: 10px;
    margin-top: 1px;
}

.gr__score-wrap {
    margin-right: 10px;
}

.gr__score {
    color: #fff;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.5px;
}

.gr__rank {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 800;
    color: rgba(255, 255, 255, 0.3);
    background: rgba(255, 255, 255, 0.04);
    flex-shrink: 0;
}

.gr__rank--gold {
    background: linear-gradient(135deg, #C59014, #A67B10);
    color: #fff;
    box-shadow: 0 2px 10px rgba(197, 144, 20, 0.35);
}

.gr__rank--silver {
    background: linear-gradient(135deg, #6B7280, #4B5563);
    color: #fff;
    box-shadow: 0 2px 8px rgba(107, 114, 128, 0.3);
}

.gr__rank--bronze {
    background: linear-gradient(135deg, #B45309, #92400E);
    color: #fff;
    box-shadow: 0 2px 8px rgba(180, 83, 9, 0.3);
}

.gr__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 10px;
    color: rgba(255, 255, 255, 0.25);
    font-size: 13px;
}
</style>
